export default __webpack_public_path__ + "static/media/albania.e985bf46.webp";